import React from 'react';
import { ConstCss } from '../../const/Const';
import { ReactComponent as FreezeIcon } from '../../svg/freezeIcon.svg'

const IconFreeze = () => {
    return (
        <div style={{ ...ConstCss.flexCenter, cursor: 'pointer' }}>
            <FreezeIcon />
        </div>
    );
}

export default IconFreeze;